import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import OrderListItem from '../components/OrderListItem'
import TableHeaderCell from '_core/components/Table/TableHeaderCell'
import { RootState } from 'setup'
import { setOrderBy } from '../../redux/order/ordersSlice'
import { setCurrentPage } from 'app/redux/pagingSlice'

type Props = {
  onOrderBy: (orderBy: string) => void
  orders: any[]
  children?: React.ReactNode
  onDelete: (id: string) => void
  filter: any
}
const OrderListWithItem: FC<Props> = ({onOrderBy, onDelete, children, orders, filter}) => {
  const dispatch = useDispatch()

  const paging = useSelector<RootState>(({misc}) => misc.paging) as any

  const handleSort = async (orderBy: any) => {
    dispatch(setCurrentPage(1))
    dispatch(setOrderBy(orderBy))
    onOrderBy(orderBy)
  }

  return (
    <div className='row mb-5'>
      <div className='table-responsive'>
        <table
          id='OrderList'
          className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'
        >
          <thead>
            <tr className='fw-bolder text-muted'>
              <TableHeaderCell sort id='order_Number' onClick={handleSort} className='min-w-100px'>
                Order Number
              </TableHeaderCell>
              <TableHeaderCell sort id='created_At' onClick={handleSort} className='min-w-100px'>
                Date
              </TableHeaderCell>
              <TableHeaderCell onClick={handleSort} className='min-w-140px'>
                Customer
              </TableHeaderCell>
              <TableHeaderCell sort id='total_Price' onClick={handleSort}>
                Total
              </TableHeaderCell>
              <TableHeaderCell onClick={handleSort}>Items</TableHeaderCell>
              <TableHeaderCell
                sort
                id='order_delivery_method'
                onClick={handleSort}
                className='min-w-140px '
              >
                Delivery Type
              </TableHeaderCell>
              <TableHeaderCell>Order Type</TableHeaderCell>
              <TableHeaderCell
                sort
                id='financial_Status'
                onClick={handleSort}
                className='min-w-140px '
              >
                Payment status
              </TableHeaderCell>
              <TableHeaderCell
                sort
                id='fulfillment_Status'
                onClick={handleSort}
                className='min-w-140px'
              >
                Fulfillment status
              </TableHeaderCell>
              <th className=' min-w-100px text-center'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders &&
              orders.map((order: any) => (
                <OrderListItem key={order.id} order={order} onDelete={onDelete} filter={filter} />
              ))}
          </tbody>
        </table>
        {!paging.totalCount && !orders.length && (
          <>
            <div className='py-10 text-gray-600 text-center justify-content-center '>
              No orders found.
            </div>
          </>
        )}
        {children}
      </div>
    </div>
  )
}

export default OrderListWithItem
